/**
 * Grafana connector form hints shared by ConnectorsPage and tests.
 */
export const GRAFANA_CONNECTOR_TYPE = 'grafana';

export const AUTH_SERVICE_ACCOUNT = 'service_account_token';
export const AUTH_WORKSPACE_API_KEY = 'workspace_api_key';

export const GRAFANA_AUTH_TYPE_OPTIONS = [
  {
    value: AUTH_SERVICE_ACCOUNT,
    label: 'Manual — service account token',
  },
  {
    value: AUTH_WORKSPACE_API_KEY,
    label: 'Auto-refresh — AWS workspace API key',
  },
];

export const GRAFANA_PLACEHOLDERS = {
  base_url: 'https://g-xxxx.grafana-workspace.us-east-1.amazonaws.com',
  workspace_id: 'g-0b79e25482',
  region: 'us-east-1',
  org_id: '1',
  timeout_seconds: '30',
  default_folder_uid: 'folder-uid',
  default_dashboard_uid: 'dashboard-uid',
};

export const GRAFANA_TOKEN_LABEL = 'Service account token';

export const GRAFANA_BASE_URL_HINT = 'HTTPS Grafana / Managed Grafana workspace URL';

export function isGrafanaDatasourceType(typeDef) {
  return typeDef?.type === GRAFANA_CONNECTOR_TYPE && typeDef?.category === 'datasource';
}

export function credentialLabelFor(typeKey, field) {
  if (typeKey === GRAFANA_CONNECTOR_TYPE && field === 'token') {
    return GRAFANA_TOKEN_LABEL;
  }
  return field;
}

/** Fields only relevant for AWS workspace API key auto-refresh. */
export const GRAFANA_AUTO_REFRESH_FIELDS = new Set(['workspace_id', 'region', 'key_role']);

export function shouldShowGrafanaConfigField(key, authType) {
  if (!GRAFANA_AUTO_REFRESH_FIELDS.has(key)) return true;
  return authType === AUTH_WORKSPACE_API_KEY;
}

export function shouldShowGrafanaTokenField(authType) {
  return authType !== AUTH_WORKSPACE_API_KEY;
}

export function grafanaAuthTypeLabel(value) {
  const hit = GRAFANA_AUTH_TYPE_OPTIONS.find((o) => o.value === value);
  return hit ? hit.label : value;
}
